// extracted by mini-css-extract-plugin
export default {"h2":"ManagerEmployees_h2__eZp5O","content":"ManagerEmployees_content__ydA28","green":"ManagerEmployees_green__4Yce9","red":"ManagerEmployees_red__O55od"};